export default __webpack_public_path__ + "static/media/dummy-pdf-placeholder.3ddcbf94.pdf";